import { Surface, Wordmark } from '@chopchop-se/ui';
import type { ReactNode } from 'react';

/** The centred card every unauthenticated screen (login, callback) sits in. */
export function AuthCard({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}): ReactNode {
  return (
    <div className="launcher-surface flex min-h-screen items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex justify-center">
          <Wordmark name="gigachop" system="wms" />
        </div>
        <Surface className="p-6">
          <h1 className="font-display text-xl font-semibold tracking-tight text-ink">{title}</h1>
          {subtitle ? <p className="mt-1.5 text-sm text-ink-muted">{subtitle}</p> : null}
          <div className="mt-5">{children}</div>
        </Surface>
        {footer ? <div className="mt-4 text-center text-sm text-ink-muted">{footer}</div> : null}
      </div>
    </div>
  );
}
